import { FETCH_STATUS_RANGE } from "../../actions/types";

const INITIAL_STATE = {
  status: [],
  headers: []
};


const statusReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_STATUS_RANGE:
      return payload;
    default:
      return state;
  }
};

export default statusReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/status_range_reducer.js